import React from "react"
import ProductCard from "../ProductCard/ProductCard"
import * as styles from "./productGrid.module.scss"

const ProductGrid = ({
    widthLeft,
    widthRight,
    gridSectionData,
    gridArrayData,
    gridArrayIcon,
    gridArrayWholeIcon=null
}) => {
    return (
      <div className={styles.product_grid_section}>
        <div
          className={styles.card_left_wrapper}
          style={{
            width: widthLeft,
            minWidth: `${widthLeft == "30%" ? "370px" : "0"}`,
          }}
        >
          <ProductCard
            fluid={gridSectionData ? gridSectionData.icon.fluid : gridArrayIcon}
            icon={
              gridSectionData &&
              gridSectionData.icon.title &&
              gridSectionData.icon.fluid &&
              gridSectionData.icon
                ? gridSectionData.icon
                : gridArrayWholeIcon
            }
            title={
              gridSectionData
                ? gridSectionData.subtitle
                : gridArrayData[0] && gridArrayData[0].subTitle
            }
            thumbnailCategoryTitle={
              gridSectionData
                 ? gridSectionData.thumbnailCategoryTitle
                : gridArrayData[0] && gridArrayData[0].thumbnailCategoryTitle 
            }

            desc={
              gridSectionData
                ? gridSectionData.sectionThumbnail[0].title
                : gridArrayData[0].title
            }
            thumbnailTitle={
              gridSectionData
                ? gridSectionData.sectionThumbnail[0].thumbnailTitle
                : gridArrayData[0].thumbnailTitle
            }
            bgImg={
              gridSectionData
                ? gridSectionData.sectionThumbnail[0].thumbnailImage[0].fluid
                : gridArrayData[0].thumbnailImage[0].fluid
            }
            bgImgTitle={
              gridSectionData
                ? gridSectionData.subtitle
                : gridArrayData[0] && gridArrayData[0].title
            }
            to={
              gridSectionData
                ? gridSectionData.sectionThumbnail[0].slug
                : gridArrayData[0].slug
            }
          />
        </div>
        {(gridArrayData?.length > 1 ||
          gridSectionData?.sectionThumbnail?.length > 1) && (
          <div
            className={styles.card_right_wrapper}
            style={{
              width: widthRight,
              minWidth: `${widthLeft == "70%" ? "0" : "370px"}`,
            }}
          >
            <ProductCard
              fluid={
                gridSectionData ? gridSectionData.icon.fluid : gridArrayIcon
              }
              icon={
                gridSectionData &&
                gridSectionData.icon.title &&
                gridSectionData.icon.fluid &&
                gridSectionData.icon
                  ? gridSectionData.icon
                  : gridArrayWholeIcon
              }
              title={
                gridSectionData
                  ? gridSectionData.subtitle
                  : gridArrayData[0] && gridArrayData[0].subTitle
              }
              thumbnailCategoryTitle={
                gridSectionData
                   ? gridSectionData.thumbnailCategoryTitle
                  : gridArrayData[0] && gridArrayData[0].thumbnailCategoryTitle 
              } 
              desc={
                gridSectionData
                  ? gridSectionData.sectionThumbnail[1].title
                  : gridArrayData[1]?.title
              }
              thumbnailTitle={
                gridSectionData
                  ? gridSectionData.sectionThumbnail[0].thumbnailTitle
                  : gridArrayData[1].thumbnailTitle
              }
              bgImg={
                gridSectionData
                  ? gridSectionData.sectionThumbnail[1].thumbnailImage[0].fluid
                  : gridArrayData[1]?.thumbnailImage[0].fluid
              }
              bgImgTitle={
                gridSectionData
                  ? gridSectionData.subtitle
                  : gridArrayData[0] && gridArrayData[0].title
              }
              to={
                gridSectionData
                  ? gridSectionData.sectionThumbnail[1].slug
                  : gridArrayData[1].slug
              }
            />
          </div>
        )}
      </div>
    )
}

export default ProductGrid
